import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { FinancialYear } from '../entity/financialyear';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { BLService } from './bl.service';

@Injectable()
export class FinancialYearService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'financial-year';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  getFinancialYearsForClientId(id: number): Observable<FinancialYear[]> {
    const queryParam = '?order=DESC';
    return this.http
      .get<FinancialYear[]>(`${this.url}/${id}${queryParam}`, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }

  saveFinancialYear(financialYear: FinancialYear): Observable<FinancialYear> {
    const body = JSON.stringify(financialYear);

    return this.http
      .put<FinancialYear>(this.url, body, this.options.getAuthorizationHeader())
      .pipe(this.catchErrorAndShowMessage());
  }

  addNextFinancialYear(clientId: number): Observable<FinancialYear> {
    return this.http
      .put<FinancialYear>(`${this.url}/next/${clientId}`, '', this.options.getAuthorizationHeader())
      .pipe(this.catchErrorAndShowMessage());
  }

  deleteFinancialYearWithId(financialYearIdid: number): Observable<FinancialYear[]> {
    return this.http
      .delete<FinancialYear[]>(`${this.url}/${financialYearIdid}`, this.options.getAuthorizationHeaderWithEmptyBody())
      .pipe(this.catchErrorAndShowMessage());
  }
}
